// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mn18","textarea":"styles_textarea__36rXh"};